import React from 'react';
import { AppView, Button, ButtonGroup, rem, withAnimatedNavigationHeader, } from 'design-system';
import { IconEmma } from 'design-system/icons/IconEmma';
import Squircle from 'design-system/Squircle';
import StatusBar from 'design-system/StatusBar';
import { SuccessView } from 'design-system/SuccessView';
import useColors from 'hooks/useColors';
import useDuplicateReviewStep from '../hooks/useDuplicateReviewStep';
import { duplicateReviewStrings } from '../utils/duplicateReview';
import { getSubscriptionName } from '../utils/subscriptionName';
const strings = {
    pageTitle: 'Cancel duplicate',
    title: (name) => `Cancel with ${name}`,
    subTitle: (name, count) => [
        `You will need to cancel this directly via ${name}’s website or app, as Emma can’t manage external provider contracts for you.`,
        `Once you’ve done that, tap “${duplicateReviewStrings.alreadyCancelled(count)}” to update your tracking in Emma.`,
    ],
    gotIt: 'Got it',
};
const DuplicateCancelScreen = withAnimatedNavigationHeader(({ navigation, route }) => {
    const colors = useColors();
    // Got it only moves on: once they've cancelled with the merchant, "I've
    // already cancelled" on the review records it.
    const { group, goToNextStep } = useDuplicateReviewStep(navigation, route.params);
    if (!group)
        return null;
    const name = getSubscriptionName(group[0]);
    return (<AppView withFrame={false}>
        <StatusBar barStyle="dark-content" animated/>
        <SuccessView title={strings.title(name)} subTitle={strings.subTitle(name, group.length)} icon={<Squircle width={rem(88)} height={rem(88)} color={colors.cards.onDark}>
              <IconEmma width={rem(54)} height={rem(54)} color={colors.elements.brand}/>
            </Squircle>}/>
        <ButtonGroup type="floating">
          <Button brand title={strings.gotIt} onPress={goToNextStep} testID="duplicate-cancel-got-it"/>
        </ButtonGroup>
      </AppView>);
}, ({ colors }) => ({
    title: '',
    pageTitle: strings.pageTitle,
    headerColorOutputRange: [
        colors.background.dark,
        colors.cards.onDark,
    ],
}));
export default DuplicateCancelScreen;
